import React, { Component } from 'react';
import Swiper from 'react-id-swiper';
import styled from 'styled-components';
import Left from 'react-icons/lib/fa/angle-left';
import Right from 'react-icons/lib/fa/angle-right';
import { media } from 'lib/style-utils';
import ListIcon from 'components/Lookbook/ListIcon';

const SwiperWrapper = styled.div`
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;

    .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
        top: auto;
        bottom: 50px !important;
    }
`;

const Btn = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 70px;
    color: #fff;
    line-height: 50px;
    padding-bottom: 5px;
    cursor: pointer;
    z-index: 15;

    ${media.mobile`
        font-size: 40px;
        top: 279px;
        transform: translateY(0);
    `}
    ${media.iphone67p`
        top: 313px;
    `}
    ${media.iphone67`
        top: 279px;
    `}
`;

const BtnBackground = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: #999;
    opacity: 0.3;
    z-index: 10;

    ${media.mobile`
        width: 50px;
        height: 50px;
        top: 285px;
        transform: translateY(0);
    `}
    ${media.iphone67p`
        top: 320px;
    `}
    ${media.iphone67`
        top: 285px;
    `}
`;

const BtnLeftBackground = BtnBackground.extend`
    left: 50px;

    ${media.mobile`
        left: 20px;
    `}
`;

const BtnRightBackground = BtnBackground.extend`
    right: 50px;

    ${media.mobile`
        right: 20px;
    `}
`;

const BtnLeft = Btn.extend`
    left: 58px;

    ${media.mobile`
        left: 24px;
    `}
`;

const BtnRight = Btn.extend`
    right: 58px;

    ${media.mobile`
        right: 24px;
    `}
`;

const Img = styled.div`
    width: 100%;
    height: 100vh;
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    ${media.tablet`
        background-size: cover;
        background-position: top;
    `}
`;

const Bottom = styled.div`
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 1920px;
    width: 100%;
    height: 300px;
    margin: 0 auto;
    overflow: hidden;
    z-index: 10;

    ${media.mobile`
        height: 150px;
    `}
`;

const Circle = styled.div`
    position: absolute;
    bottom: -450px;
    left: 50%;
    transform: translateX(-50%);
    width: 4000px;
    height: 2500px;
    border: 500px solid ${props => props.color};
    border-radius: 50%;

    ${media.tablet`
        width: 3000px;
    `}
    ${media.w800`
        width: 2500px;
    `}
    ${media.mobile`
        width: 2000px;
        bottom: -450px;
    `}
`;

class Gallery extends Component {

    shouldComponentUpdate(nextProps, nextState) {
        return this.props !== nextProps;
    }

    componentDidUpdate(prevProps, prevState) {
        this.swiper.onResize();
    }

    componentDidMount() {
        window.scrollTo(0,0);
        const { DataActions, lookbookData, match } = this.props;
        const index = match.params.index;

        if (!lookbookData[index] || lookbookData[index].seasonText === '') {
            DataActions.getLookbook();
        }
    }

    prev = () => {
        this.swiper.slidePrev();
    }

    next = () => {
        if (this.swiper) {
            this.swiper.slideNext();
        } else {
            this.swiper.init();
        }
    }

    handleGoBack = () => {
        this.props.history.goBack();
    }

    render() {
        const { prev, next, handleGoBack } = this;
        const { color, lookbookData, galleryIndex, match } = this.props;
        const index = match.params.index;

        /** Swiper init */
        const params = {
            spaceBetween: 0,
            loop: true,
            initialSlide: parseInt(galleryIndex, 10),
            onInit: (swiper) => {
                this.swiper = swiper;
            }
        };

        return (
            <SwiperWrapper>
                <Swiper {...params}>
                    {
                        lookbookData[index] && lookbookData[index].images.map((image, i) => {
                            return (
                                    <Img key={image._id} src={image.url} alt=""/>
                            );
                        })
                    }
                </Swiper>

                <BtnLeftBackground/>
                <BtnLeft><Left onClick={prev}/></BtnLeft>
                <BtnRightBackground/>
                <BtnRight><Right onClick={next}/></BtnRight>

                <ListIcon onClick={handleGoBack}/>

                <Bottom>
                    <Circle color={color}/>
                </Bottom>
            </SwiperWrapper>
        );
    }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Lookbook/Gallery.js